'use strict';

var baseSearch = require('base/search/search.js');
var initNostoSearch = require('./nostoSearch');
var categoryRecommendationPlacementId = 'categorypage-nosto-2';

function isNostoSearchPage() {
    return !!document.querySelector('.search-page');
}

function normalizeSortRule(value) {
    var normalized = String(value || '').toLowerCase().trim();

    if (!normalized || normalized === 'bestmatches' || normalized.indexOf('best match') > -1) {
        return 'bestmatches';
    }

    if (normalized.indexOf('price-low-to-high') > -1 || normalized.indexOf('low to high') > -1) {
        return 'price-low-to-high';
    }

    if (normalized.indexOf('price-high-to-low') > -1 || normalized.indexOf('high to low') > -1) {
        return 'price-high-to-low';
    }

    if (normalized.indexOf('newest') > -1) {
        return 'newest';
    }

    if (normalized.indexOf('promo') > -1 || normalized.indexOf('top-seller') > -1) {
        return 'promo';
    }

    return normalized;
}

function getNostoSortRule($select) {
    var selectedOption = $select.find('option:selected');
    var optionRule = selectedOption.data('id');
    var selectedValue = $select.val();
    var parsedUrl;
    var sruleValue;

    if (optionRule) {
        return normalizeSortRule(optionRule);
    }

    if (!selectedValue || selectedValue === 'sort') {
        return 'bestmatches';
    }

    try {
        parsedUrl = new URL(selectedValue, window.location.origin);
        sruleValue = parsedUrl.searchParams.get('srule');
        return normalizeSortRule(sruleValue || selectedValue);
    } catch (error) {
        return normalizeSortRule(selectedValue);
    }
}

function initNostoCategoryRecommendation() {
    var recommendations = document.querySelectorAll('.nosto-category-page-recommendation');

    if (!recommendations.length) {
        return;
    }

    if (!document.querySelector('.nosto-category-page-recommendation .js-nosto-reco')) {
        return;
    }

    if (window['__loadedNostoPlacements']) {
        delete window['__loadedNostoPlacements'][categoryRecommendationPlacementId];
    }

    if (typeof window.runNostoReco === 'function') {
        window.runNostoReco();
    }
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });
    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.js-reset-btn',
        '.js-no-search-results'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });

    initNostoCategoryRecommendation();
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    // $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            // $.spinner().stop();
        },
        error: function () {
            // $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Show second image on hover in PLP
 */
baseSearch.showSecondImage = function(){
    $('.product-tile').on('mouseover', 
        function () {
            if ($(this).closest('.product').find('.product-tile').hasClass('banner-tile')) {
                return;
            }
            var imageEl = $(this).find('.image-container .tile-image');
            var secondImage = imageEl.data('secondimage');
            if (secondImage != null && secondImage != "") {
                // set new images
                imageEl.attr('src', secondImage);
            }
        }
    );
    $('.product-tile').on('mouseout', 
        function () {
            if ($(this).closest('.product').find('.product-tile').hasClass('banner-tile')) {
                return;
            }
            var imageEl = $(this).find('.image-container .tile-image');
            var ogImage = imageEl.data('ogimage');
            if (ogImage != null && ogImage != "") {
                // set new images
                imageEl.attr('src', ogImage);
            }
        }
    );
};

baseSearch.applyFilter = function () {
    // Handle refinement value selection and reset click
    $('.container').on(
        'click',
        '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
        function (e) {
            if (isNostoSearchPage()) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);
            // $.spinner().start();
            $this.trigger('search:filter', e);
            var currentUrl = $this.data('href');
            var action = $this.data('action');
            var attributeId = '#' + $this.find('span').last().attr('id');
            var hostURL = window.location.href;
            var refinedURL = hostURL.split('?')[0] +'?'+ currentUrl.split('?')[1];
            var urlObj = new URL(hostURL);
            var srulevalue = urlObj.searchParams.get("srule");
            if(srulevalue != null && srulevalue != undefined && action != 'reset'){
                refinedURL = refinedURL + '&srule=' + srulevalue;
                currentUrl = currentUrl + '&srule=' + srulevalue;
                $('.sort-text').addClass('d-none');
            }
            $.ajax({
                url: currentUrl,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: $this.data('href')
                },
                method: 'GET',
                success: function (response) {
                    parseResults(response);
                    // $.spinner().stop();
                    var $thisAriaLabelSpan = $(attributeId)
                    var $hideShowLi = $thisAriaLabelSpan.closest('.hide-show-li');

                    if($hideShowLi.hasClass('d-none')){
                        $hideShowLi.removeClass('d-none');
                    } else {
                        $hideShowLi.addClass('d-none');
                    }

                    window.history.replaceState({}, null, refinedURL);
                    // handle toggle refinement block - Mobile Viewport
                    $('.refinements-mobile-clp').on('click', '.refinement-header', function (e) {
                        e.stopPropagation();
                        $(this).toggleClass('active');
                    });
                    $thisAriaLabelSpan.parent('button').focus();
                    SiteAccessibility.updatesAnnouncement('.search-result-count')

                },
                error: function () {
                    // $.spinner().stop();
                    $(attributeId).parent('button').focus();
                }
            });
        });
} 


/**
 * Code for view more and view less button
 */
baseSearch.viewMoreHideShow = function () {

    $(document).on('click','.refinement-less-more', function(e){
        var $hideShowLis = $(this).closest('.card-body').find('.hide-show-li');
        var $this = $(this);
        if($hideShowLis.hasClass('d-none')){
            $hideShowLis.removeClass('d-none');
            $this.html($this.data('viewless'));
        } else {
            $hideShowLis.addClass('d-none');
            $this.html($this.data('viewmore'));
        }
    });
};

var updateImpressions = function () {
    if (window.analyticsJSON && window.analyticsJSON.PRODUCT) {
      var impressions = [];
      $('#product-search-results .product-tile').not('.banner-tile').each(function () {
        impressions.push(JSON.parse($(this).attr('data-tagdata')));
      });
      window.analyticsJSON.PRODUCT = impressions;
    }
};

/*
 * this will update the ensighten data layer object
 */
baseSearch.updateImpressions = updateImpressions;

/**
 * Display refinements bar when Menu icon clicked
 */
baseSearch.filter = function () {
    $('.container').on('click', 'button.filter-results', function () {
        $('.refinement-bar, .modal-background').show();
        $('.refinement-bar').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('body').addClass('mobile-filter-open');
        $('.refinement-bar .close').focus();
    });
};

/**
 * Refinements close button
 */
baseSearch.closeRefinements = function () {
    $('.container').on('click', '.refinement-bar button.close, .modal-background', function () {
        $('.refinement-bar, .modal-background').hide();
        $('.refinement-bar').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('body').removeClass('mobile-filter-open');
        $('.btn.filter-results').focus();
    });
};


baseSearch.pagination = function () {
    $(window).on('popstate', function () {
        if (history.state && 'search' === history.state.name) {
            window.location = location.href;
        }
    });

    // Show more products
    $(document).on('click', '.pagination-link, .pagination-arrow-step, .pagination-arrow', function (e) {
        if (isNostoSearchPage()) {
            return;
        }

        e.stopPropagation();
        var paginationURL = $(this).attr('href');
        var currentURL = $(this).data('current-url');
        e.preventDefault();

        $.spinner().start();
        $.ajax({
            url: paginationURL,
            data: { selectedUrl: paginationURL },
            method: 'GET',
            success: function (response) {
                if (location.href.indexOf('sz=') === -1) {
                    history.replaceState({name: 'search'}, '', location.href);
                }
                history.pushState({name: 'search'}, '', currentURL);
                $('.product-grid').html(response);
                updateSortOptions(response);
                updateImpressions();
                initNostoCategoryRecommendation();
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};

baseSearch.showMore = function () {
    // Show more products
    $('.container').on('click', '.show-more button', function (e) {
        if (isNostoSearchPage()) {
            return;
        }

        e.stopPropagation();
        var showMoreUrl = $(this).data('url');
        e.preventDefault();

        // $.spinner().start();
        $(this).trigger('search:showMore', e);
        $.ajax({
            url: showMoreUrl,
            data: { selectedUrl: showMoreUrl },
            method: 'GET',
            success: function (response) {
                $('.grid-footer').replaceWith(response);
                updateSortOptions(response);
                updateImpressions();
                initNostoCategoryRecommendation();
                // $.spinner().stop();
            },
            error: function () {
                // $.spinner().stop();
            }
        });
    });
}

baseSearch.sort = function () {
    var $sortRoot = $('.search-results');

    if (!$sortRoot.length) {
        $sortRoot = $('.container');
    }

    // Handle sort order menu selection
    $sortRoot.on('change', '[name=sort-order]', function (e) {
        e.stopPropagation();

        if (isNostoSearchPage()) {
            var rule = getNostoSortRule($(this));
            var currentUrl = new URL(window.location.href);

            e.preventDefault();

            if (!rule || rule === 'bestmatches') {
                currentUrl.searchParams.delete('srule');
                $('.sort-text').removeClass('d-none');
            } else {
                currentUrl.searchParams.set('srule', rule);
                $('.sort-text').addClass('d-none');
            }

            currentUrl.searchParams.set('start', '0');
            currentUrl.searchParams.set('sz', currentUrl.searchParams.get('sz') || '24');
            currentUrl.searchParams.set('page', '1');
            window.history.replaceState({}, '', currentUrl.toString());

            if (typeof window.runSearch === 'function') {
                window.runSearch();
            }
            return;
        }

        e.preventDefault();

        // $.spinner().start();
        $(this).trigger('search:sort', this.value);
        var hostURL = window.location.href;
        var urlObj = new URL(this.value);
        var srulevalue = urlObj.searchParams.get("srule");
        var langVal = urlObj.searchParams.get("lang");
        var pageUrl = '';
        if(srulevalue != null && srulevalue != undefined){
            urlObj.searchParams.set("srule", srulevalue);
            pageUrl = hostURL.split('?')[0] + urlObj.search;
            $('.sort-text').addClass('d-none');
        } else {
            pageUrl = hostURL + '&srule=' +  srulevalue;
        }

        $.ajax({
            url: this.value,
            data: { selectedUrl: this.value },
            method: 'GET',
            success: function (response) {
                $('.product-grid').empty().html(response);
                // $.spinner().stop();
                window.history.replaceState({}, null, pageUrl);
                initNostoCategoryRecommendation();
            },
            error: function () {
                // $.spinner().stop();
            }
        });
    });
}

/**
 * Initialize Shoppable Banners Carousel
 */
baseSearch.initShoppableBannersCarousel = function () {
    // Initialize carousel with fluid/scalable banners
    var $carousel = $('.shoppable-banners-carousel');
    if ($carousel.length > 0) {
        var slideCount = $carousel.find('.shoppable-banner-slide').length;
        
        if (slideCount > 0 && !$carousel.hasClass('slick-initialized')) {
            var showArrows = slideCount > 5;
            var enableInfinite = slideCount > 5;
            
            console.log('Shoppable banners - slideCount:', slideCount, 'showArrows:', showArrows, 'enableInfinite:', enableInfinite);
            
            if (slideCount < 5) {
                var $wrapper = $carousel.closest('.shoppable-banners-wrapper');
                $wrapper.addClass('align-left');
                
                $carousel.on('init', function(event, slick) {
                    console.log('Slick init event fired, applying left alignment for', slideCount, 'banners');
                });
            }
            
            $carousel.slick({
                infinite: enableInfinite,
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: showArrows,
                dots: false,
                autoplay: false,
                adaptiveHeight: false,
                centerMode: false, // Disable centerMode to fix alignment
                centerPadding: '0px',
                prevArrow: '<button type="button" class="slick-prev">Previous</button>',
                nextArrow: '<button type="button" class="slick-next">Next</button>',
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            arrows: slideCount > 4,
                            infinite: slideCount > 4,
                            centerMode: false,
                            centerPadding: '0px'
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            arrows: slideCount > 3,
                            infinite: slideCount > 3,
                            centerMode: false,
                            centerPadding: '0px',
                            initialSlide: 0,
                            variableWidth: false
                        }
                    }
                ]
            });
            
            if (slideCount < 5) {
                console.log('Carousel initialized with', slideCount, 'banners and align-left class applied');
            }
        }
    }
};

baseSearch.windowLoad = function () {
    $(document).ready(function () {
        // Initialize shoppable banners carousel on document ready
        setTimeout(function() {
            baseSearch.initShoppableBannersCarousel();
        }, 100);
    });
    
    $(window).on('load', function () {
        var hostURL = window.location.href;
        var urlObj = new URL(hostURL);
        var srulevalue = urlObj.searchParams.get("srule");
        if(srulevalue != null && srulevalue != undefined){
            $('.sort-text').addClass('d-none');
        }

        $('.js-no-search-results').on('click', '.refinement-header', function () {
            $(this).toggleClass('active');
        });
        
        // Initialize shoppable banners carousel again on window load as fallback
        baseSearch.initShoppableBannersCarousel();
    });
}

baseSearch.nostoSearch = function () {
    initNostoSearch();
    initNostoCategoryRecommendation();
};

module.exports = baseSearch;
